import camelCase        from 'lodash/camelCase'
import WizardController from '../../../wizard_controller'

export default class extends WizardController {

  static targets = [
    'educationTopicNoneOfTheAbove'
  ]

  toggleNoneOfTheAbove({ currentTarget, params: { sectionType } }) {
    const targetsKey = camelCase(`${sectionType}_none_of_the_above_targets`)

    this.toggleCheckboxNoneOfTheAbove({
      input:         currentTarget,
      targets:       this[targetsKey],
      dispatchInput: false
    })
  }

}
